export default __webpack_public_path__ + "static/media/Book-Search-Engine.7f20cef7.png";